import { WebAppProject } from "../../../../library-js/web-app/project/WebAppProject";
import { WebApp } from "../../../../library-js/web-app/WebApp";
import { Rokojori } from "../../Rokojori";


export abstract class RokojoriWebApp<C,P extends WebAppProject> extends WebApp<C,P>
{
  protected _rokojori:Rokojori;
  get $():Rokojori{ return this._rokojori; }
  
  abstract start( e:Element ):void;

  constructor( rokojori:Rokojori )
  {
    super();
    this._rokojori = rokojori;
  }
  
}   